import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'pascalCaseToSplit' })
export class SplitPascalCaseStringPipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {string} value
     * @param {any[]} args
     * @returns {string}
     */
    transform(value: string, args: any[] = []): string {
        if (value) {
            const lowerCaseValue = _.startCase(value).toLowerCase(); // RataFissaInps => Rata Fissa Inps => rata fissa inps
            return lowerCaseValue.charAt(0).toUpperCase() + lowerCaseValue.slice(1); // Rata fissa inps
        } else {
            return null;
        }
    }
}
